<template>
  <b-row>
    <b-col xl="12" lg="12">
      <Widget>
        <b-row>
          <b-col md="6" style="height: 30px">
            <h4>Penilaian Teknis</h4>
          </b-col>
          <b-col md="6" style="height: 30px">
            <div style="float: right">
              <b-button v-if="dataPermohonan.catatan_ba_direktur != null" variant="outline-primary" v-b-modal.modal-catatan>
                <main rel="main">
                  <div class="notification">
                    <svg viewbox="-10 0 60 60" width="60" height="60">
                      <path class="notification--bell"
                        d="M14 12v1H0v-1l0.73-0.58c0.77-0.77 0.81-3.55 1.19-4.42 0.77-3.77 4.08-5 4.08-5 0-0.55 0.45-1 1-1s1 0.45 1 1c0 0 3.39 1.23 4.16 5 0.38 1.88 0.42 3.66 1.19 4.42l0.66 0.58z">
                      </path>
                      <path class="notification--bellClapper" d="M7 15.7c1.11 0 2-0.89 2-2H5c0 1.11 0.89 2 2 2z"></path>
                    </svg>
                  </div>
                </main> <span style="margin-left:20px">Catatan</span>
              </b-button>

            </div>
          </b-col>
        </b-row>
        <form-wizard shape="tab" color="#3498db" title="" subtitle="" @on-change="updateProgress"
          @on-loading="updateProgress(1, 1)">
          <b-progress class="progress-xs" variant="info" :value="progress" :max="3" />
          <b-button slot="prev" variant="primary" id="back" hidden class="text-white">
            <i class="fa fa-caret-left" /> Previous
          </b-button>
          <b-button slot="next" variant="primary" id="next" hidden class="text-white">
            Next <i class="fa fa-caret-right" />
          </b-button>
          <b-button @click="$router.push('/app/notifikasi-izin-lokasi')" slot="finish" variant="success" id="finish" hidden
            class="text-white">
            Finish <i class="fa fa-check" />
          </b-button>
          <tab-content title="1. Profil">
            <Profil @nextDokumen="nextDokumen" :dataPermohonan="dataPermohonan" :dataKBLI="dataKBLI" :dataSkalaUsaha="dataSkalaUsaha"
              :dataKlasifikasi="dataKlasifikasi"></Profil>
            <!-- <div class="row justify-content-between">
              <div class="col-4">
                <div class="text-left">
                  <b-button @click="$router.push('/app/notifikasi-izin-lokasi')" variant="danger">Back</b-button>
                </div>
              </div>
              <div class="col-4">
                <div class="text-right">
                  <b-button @click="simpanProfil()" style="float: right" variant="primary">Next <i
                      class="fa fa-caret-right" />
                  </b-button>
                </div>
              </div>
            </div> -->
          </tab-content>
          <tab-content title="2. Dokumen">
            <b-form>
              <legend><strong>Dokumen</strong></legend>
              <b-row>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">Koordinat</p>
                </b-col>
                <b-col md="3"> </b-col>
                <b-col md="4">
                  <b-form-group>
                    <b-button variant="success" v-if="dataPermohonan.file_kordinat == null" disabled
                      data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                      style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                    <a :href="dataPermohonan.file_kordinat" v-else type="button" class="btn btn-success" target="_blank"
                      rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                  </b-form-group>
                </b-col>
                <div class="divider div-transparent"></div>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Rencana Bangunan dan Instalasi di Laut
                  </p>
                </b-col>
                <b-col md="3"> </b-col>
                <b-col md="4">
                  <!-- <b-button variant="success" v-if="dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <b-button variant="success" v-if="
                    dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut ==
                    null
                  " disabled data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                    style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                  <a :href="dataPermohonan.file_rencana_bangunan_dan_instalasi_di_laut
                    " v-else type="button" class="btn btn-success" target="_blank" rel="noopener noreferrer"><i
                      class="fa fa-download" /> Download</a>
                </b-col>
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1 hr-blurry" md="12">
                        </b-col> -->
                <b-col md="12">
                  <div class="hr-sect">Rencana Kegiatan</div>
                </b-col>
                <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col> -->
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->

                <b-col md="8">
                  <div>
                    Dokumen dasar berupa kegiatan, tujuan dan manfaat kegiatan
                    usaha
                  </div>
                </b-col>
                <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled v-model="dataPermohonan.verifikasi_dokumen_dasar"
                      @change="simpanIndikator('verifikasi_dokumen_dasar')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault" />
                    <label class="form-check-label" for="flexSwitchCheckDefault">{{
                      dataPermohonan.verifikasi_dokumen_dasar
                        ? "Sesuai"
                        : "TIdak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>

                <b-col md="5">
                  <div>Kegiatan eksisting yang dimohonkan</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled v-model="dataPermohonan.verifikasi_kegiatan_eksisting"
                      @change="simpanIndikator('verifikasi_kegiatan_eksisting')" class="form-check-input"
                      type="checkbox" id="flexSwitchCheckDefault2" />
                    <label class="form-check-label" for="flexSwitchCheckDefault2">{{
                      dataPermohonan.verifikasi_kegiatan_eksisting
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Rencana jadwal pelaksanaan kegiatan utama dan pendukungnya
                  </div>
                </b-col>
                <!-- <b-col md="3">
                            <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group>
                        </b-col> -->
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled v-model="dataPermohonan.verifikasi_rencana_jadwal"
                      @change="simpanIndikator('verifikasi_rencana_jadwal')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault3" />
                    <label class="form-check-label" for="flexSwitchCheckDefault3">{{
                      dataPermohonan.verifikasi_rencana_jadwal
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Rencana tapak/site plan kegiatan yang dilengkapi dengan
                    rencana bangunan dan instalasi di laut serta fasilitas
                    penunjangnya
                  </div>
                </b-col>
                <!-- <b-col md="3"> -->
                <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                <!-- </b-col> -->
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled v-model="dataPermohonan.verifikasi_rencana_site_plan"
                      @change="simpanIndikator('verifikasi_rencana_site_plan')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault4" />
                    <label class="form-check-label" for="flexSwitchCheckDefault4">{{
                      dataPermohonan.verifikasi_rencana_site_plan
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Deksriptif luasan (Ha) yang dibutuhkan pada lokasi usaha
                    yang dimohonkan per kegiatan utama dan penunjangnya
                  </div>
                </b-col>
                <!-- <b-col md="3">
                            <b-form-group> -->
                <!-- <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file> -->
                <!-- </b-form-group>
                        </b-col> -->
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled v-model="dataPermohonan.verifikasi_deskriptif_luasan"
                      @change="simpanIndikator('verifikasi_deskriptif_luasan')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault5" />
                    <label class="form-check-label" for="flexSwitchCheckDefault5">{{
                      dataPermohonan.verifikasi_deskriptif_luasan
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>
                    Peta lokasi/plotting batas-batas area dan/atau jalur
                    disertai titik koordinat lokasi dengan sistem koordinat
                    lintang (latitude) dan bujur (longitude) berskala minimal
                    1:50.000.
                  </div>
                </b-col>

                <b-col md="4">
                  <!-- <b-form-group> -->
                  <div class="form-check form-switch">
                    <input disabled v-model="dataPermohonan.verifikasi_peta_lokasi"
                      @change="simpanIndikator('verifikasi_peta_lokasi')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault6" />
                    <label class="form-check-label" for="flexSwitchCheckDefault6">{{
                      dataPermohonan.verifikasi_peta_lokasi
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>
                    <p style="font-weight: 900; font-size: 17px">
                      Informasi Pemanfaatan Ruang Laut
                    </p>
                  </div>
                </b-col>
                <b-col md="3"> </b-col>
                <b-col md="4">
                  <b-form-group>
                    <!-- <b-button variant="success" v-if="dataPermohonan.file_informasi_prl != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <b-button variant="success" v-if="dataPermohonan.file_informasi_prl == null" disabled
                      data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                      style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                    <a :href="dataPermohonan.file_informasi_prl" v-else type="button" class="btn btn-success"
                      target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                    <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                  </b-form-group>
                </b-col>
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="5">
                  <div>
                    <p style="font-weight: 900; font-size: 17px">
                      Data kondisi terkini lokasi dan sekitarnya (ekosistem,
                      hidrografi, dan oseanografi)
                    </p>
                  </div>
                </b-col>
                <b-col md="3"> </b-col>
                <b-col md="4">
                  <!-- <b-button variant="success" v-if="dataPermohonan.file_data_kondisi_terkini != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <b-button variant="success" v-if="dataPermohonan.file_data_kondisi_terkini == null" disabled
                    data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                    style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                  <a :href="dataPermohonan.file_data_kondisi_terkini" v-else type="button" class="btn btn-success"
                    target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                </b-col>
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="12">
                  <div class="hr-sect">Ekosistem Sekitar</div>
                </b-col>
                <!-- <b-col md="3">
                        </b-col>
                        <b-col md="4">
                        </b-col> -->
                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="5">
                  <div>Mangrove</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled v-model="dataPermohonan.verifikasi_magrove"
                      @change="simpanIndikator('verifikasi_magrove')" class="form-check-input" type="checkbox"
                      id="flexSwitchCheckDefault7" />
                    <label class="form-check-label" for="flexSwitchCheckDefault7">{{
                      dataPermohonan.verifikasi_magrove
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Lamun</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="simpanIndikator('verifikasi_lamun')"
                      v-model="dataPermohonan.verifikasi_lamun" type="checkbox" id="flexSwitchCheckDefault8" />
                    <label class="form-check-label" for="flexSwitchCheckDefault8">{{
                      dataPermohonan.verifikasi_lamun
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="8">
                  <div>Terumbu karang</div>
                </b-col>

                <b-col md="4">
                  <!-- <b-form-group> 
                                <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="simpanIndikator('verifikasi_terumbu_karang')"
                      v-model="dataPermohonan.verifikasi_terumbu_karang" type="checkbox" id="flexSwitchCheckDefault9" />
                    <label class="form-check-label" for="flexSwitchCheckDefault9">{{
                      dataPermohonan.verifikasi_terumbu_karang
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                </b-col>

                <!-- <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="12">
                  <div class="hr-sect">Hidro-oseanografi</div>
                </b-col>
                <!-- <b-col md="3">
                        
                        </b-col>
                        <b-col md="4">
                        
                        </b-col>
                        <b-col md="12" class="divider-col">
                            <hr class="style1" md="12">
                        </b-col> -->
                <b-col md="5">
                  <div>Arus</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="simpanIndikator('verifikasi_arus')"
                      v-model="dataPermohonan.verifikasi_arus" type="checkbox" id="flexSwitchCheckDefault10" />
                    <label class="form-check-label" for="flexSwitchCheckDefault10">{{
                      dataPermohonan.verifikasi_arus
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Gelombang</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="simpanIndikator('verifikasi_gelombang')"
                      v-model="dataPermohonan.verifikasi_gelombang" type="checkbox" id="flexSwitchCheckDefault11" />
                    <label class="form-check-label" for="flexSwitchCheckDefault11">{{
                      dataPermohonan.verifikasi_gelombang
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Pasang Surut</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="simpanIndikator('verifikasi_pasang_surut')"
                      v-model="dataPermohonan.verifikasi_pasang_surut" type="checkbox" id="flexSwitchCheckDefault12" />
                    <label class="form-check-label" for="flexSwitchCheckDefault12">{{
                      dataPermohonan.verifikasi_pasang_surut
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <div>Bathimetri</div>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="simpanIndikator('verifikasi_bathimetri')"
                      v-model="dataPermohonan.verifikasi_bathimetri" type="checkbox" id="flexSwitchCheckDefault13" />
                    <label class="form-check-label" for="flexSwitchCheckDefault13">{{
                      dataPermohonan.verifikasi_bathimetri
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-size: 15px">
                    Profil dasar laut disertai gambar
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="simpanIndikator('verifikasi_profil_dasar_laut')"
                      v-model="dataPermohonan.verifikasi_profil_dasar_laut" type="checkbox"
                      id="flexSwitchCheckDefault14" />
                    <label class="form-check-label" for="flexSwitchCheckDefault14">{{
                      dataPermohonan.verifikasi_profil_dasar_laut
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-size: 15px">
                    Kondisi/karakteristik sosial ekonomi masyarakat
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="
                      simpanIndikator('verifikasi_kondisi_sosial_ekonomi')
                      " v-model="dataPermohonan.verifikasi_kondisi_sosial_ekonomi" type="checkbox"
                      id="flexSwitchCheckDefault15" />
                    <label class="form-check-label" for="flexSwitchCheckDefault15">{{
                      dataPermohonan.verifikasi_kondisi_sosial_ekonomi
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-size: 15px">
                    Aksesibilitas lokasi dan sekitar
                  </p>
                </b-col>
                <b-col md="3">
                  <!-- <b-form-group>
                                <b-form-file
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."
                                plain
                                class="form-control"
                                ></b-form-file>
                            </b-form-group> -->
                </b-col>
                <b-col md="4">
                  <!-- <b-form-group> -->
                  <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                  <div class="form-check form-switch">
                    <input disabled class="form-check-input" @change="
                      simpanIndikator('verifikasi_aksesibilitas_lokasi')
                      " v-model="dataPermohonan.verifikasi_aksesibilitas_lokasi" type="checkbox"
                      id="flexSwitchCheckDefault16" />
                    <label class="form-check-label" for="flexSwitchCheckDefault16">{{
                      dataPermohonan.verifikasi_aksesibilitas_lokasi
                        ? "Sesuai"
                        : "Tidak Sesuai"
                    }}</label>
                  </div>
                  <!-- </b-form-group> -->
                </b-col>
                <b-col md="12" class="divider-col">
                  <hr class="style1" md="12" />
                </b-col>
                <b-col md="5">
                  <p style="font-weight: 900; font-size: 17px">
                    Persyaratan Lainnya
                  </p>
                </b-col>
                <b-col md="3"> </b-col>
                <b-col md="4">
                  <b-form-group>
                    <!-- <b-button variant="success" v-if="dataPermohonan.file_persyaratan_lain" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <b-button variant="success" v-if="dataPermohonan.file_persyaratan_lain == null" disabled
                      data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                      style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                    <a :href="dataPermohonan.file_persyaratan_lain" v-else type="button" class="btn btn-success"
                      target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                    <!-- <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                    <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                </div> -->
                  </b-form-group>
                </b-col>

                <template v-if="dataPermohonan.reklamasi == true">
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <p style="font-weight: 900; font-size: 17px">
                      Persyaratan Reklamasi
                    </p>
                  </b-col>
                  <b-col md="3"> </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <!-- <b-button variant="success" v-if="dataPermohonan.file_persyaratan_reklamasi != null" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                      <b-button variant="success" v-if="dataPermohonan.file_persyaratan_reklamasi == null" disabled
                        data-toggle="tooltip" data-placement="top" title="Tidak ada data" class="text-white"
                        style="margin-right: 5px"><i class="fa fa-download" /> Download</b-button>
                      <a :href="dataPermohonan.file_persyaratan_reklamasi" v-else type="button" class="btn btn-success"
                        target="_blank" rel="noopener noreferrer"><i class="fa fa-download" /> Download</a>
                      <!-- <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault">
                                        <label class="form-check-label" for="flexSwitchCheckDefault">Sesuai</label>
                                    </div> -->
                    </b-form-group>
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Rencana pengambilan sumber material reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input disabled class="form-check-input" @change="
                        simpanIndikator(
                          'verifikasi_rencana_pengambilan_sumber_material'
                        )
                        " v-model="dataPermohonan.verifikasi_rencana_pengambilan_sumber_material
                          " type="checkbox" id="flexSwitchCheckDefault17" />
                      <label class="form-check-label" for="flexSwitchCheckDefault17">{{
                        dataPermohonan.verifikasi_rencana_pengambilan_sumber_material
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Rencana pemanfaatan lahan reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input disabled class="form-check-input" @change="
                        simpanIndikator(
                          'verifikasi_rencana_pemanfaatan_lahan_reklamasi'
                        )
                        " v-model="dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi
                          " type="checkbox" id="flexSwitchCheckDefault18" />
                      <label class="form-check-label" for="flexSwitchCheckDefault18">{{
                        dataPermohonan.verifikasi_rencana_pemanfaatan_lahan_reklamasi
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Gambaran umum pelaksanaan reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input disabled class="form-check-input" @change="
                        simpanIndikator('verifikasi_gambaran_umum_reklamasi')
                        " v-model="dataPermohonan.verifikasi_gambaran_umum_reklamasi
                          " type="checkbox" id="flexSwitchCheckDefault19" />
                      <label class="form-check-label" for="flexSwitchCheckDefault19">{{
                        dataPermohonan.verifikasi_gambaran_umum_reklamasi
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                  <b-col md="5">
                    <div>Jadwal rencana pelaksanaan reklamasi</div>
                  </b-col>
                  <b-col md="3">
                    <!-- <b-form-group>
                                    <b-form-file
                                    placeholder="Choose a file or drop it here..."
                                    drop-placeholder="Drop file here..."
                                    plain
                                    class="form-control"
                                    ></b-form-file>
                                </b-form-group> -->
                  </b-col>
                  <b-col md="4">
                    <!-- <b-form-group> -->
                    <!-- <b-button variant="primary" class="text-white" style="margin-right:5px"><i class="fa fa-cloud-upload"/> Unggah</b-button>
                                    <b-button variant="success" class="text-white" style="margin-right:5px"><i class="fa fa-download"/> Download</b-button> -->
                    <div class="form-check form-switch">
                      <input disabled class="form-check-input" @change="
                        simpanIndikator('verifikasi_jadwal_rencana_reklamasi')
                        " v-model="dataPermohonan.verifikasi_jadwal_rencana_reklamasi
                          " type="checkbox" id="flexSwitchCheckDefault20" />
                      <label class="form-check-label" for="flexSwitchCheckDefault20">{{
                        dataPermohonan.verifikasi_jadwal_rencana_reklamasi
                          ? "Sesuai"
                          : "Tidak Sesuai"
                      }}</label>
                    </div>
                    <!-- </b-form-group> -->
                  </b-col>
                  <b-col md="12" class="divider-col">
                    <hr class="style1" md="12" />
                  </b-col>
                </template>
              </b-row>
              <b-row v-if="
                dataPermohonan.verifikasi_dokumen_dasar === true &&
                dataPermohonan.verifikasi_kegiatan_eksisting === true &&
                dataPermohonan.verifikasi_rencana_jadwal === true &&
                dataPermohonan.verifikasi_rencana_site_plan === true &&
                dataPermohonan.verifikasi_deskriptif_luasan === true &&
                dataPermohonan.verifikasi_peta_lokasi === true &&
                dataPermohonan.verifikasi_magrove === true &&
                dataPermohonan.verifikasi_lamun === true &&
                dataPermohonan.verifikasi_terumbu_karang === true &&
                dataPermohonan.verifikasi_arus === true &&
                dataPermohonan.verifikasi_gelombang === true &&
                dataPermohonan.verifikasi_pasang_surut === true &&
                dataPermohonan.verifikasi_bathimetri === true &&
                dataPermohonan.verifikasi_profil_dasar_laut === true &&
                dataPermohonan.verifikasi_kondisi_sosial_ekonomi === true &&
                dataPermohonan.verifikasi_aksesibilitas_lokasi === true
              ">
                <b-col md="6">
                  <b-form-group label="Pilih Admin Penjadwalan Pentek (Pusat/UPT) *">
                    <v-select id="default-select" :options="dataUser" :reduce="(user) => user.id" label="nama"
                      v-model="dataPermohonan.id_admin"  name="Jenis Proyek" :class="{
                        'is-invalid': errors.has('form-1.Jenis Proyek'),
                      }" disabled />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Proyek')">
                      {{ errors.first("form-1.Jenis Proyek") }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
              <div class="row" v-if="
                dataPermohonan.verifikasi_dokumen_dasar != true ||
                dataPermohonan.verifikasi_kegiatan_eksisting != true ||
                dataPermohonan.verifikasi_rencana_jadwal != true ||
                dataPermohonan.verifikasi_rencana_site_plan != true ||
                dataPermohonan.verifikasi_deskriptif_luasan != true ||
                dataPermohonan.verifikasi_peta_lokasi != true ||
                dataPermohonan.verifikasi_magrove != true ||
                dataPermohonan.verifikasi_lamun != true ||
                dataPermohonan.verifikasi_terumbu_karang != true ||
                dataPermohonan.verifikasi_arus != true ||
                dataPermohonan.verifikasi_gelombang != true ||
                dataPermohonan.verifikasi_pasang_surut != true ||
                dataPermohonan.verifikasi_bathimetri != true ||
                dataPermohonan.verifikasi_profil_dasar_laut != true ||
                dataPermohonan.verifikasi_kondisi_sosial_ekonomi != true ||
                dataPermohonan.verifikasi_aksesibilitas_lokasi != true
              ">
                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label="Catatan: *">
                      <ckeditor disabled v-model="dataPermohonan.catatan_verdok" :editor="wygEditor"></ckeditor>
                    </b-form-group>
                  </div>
                </b-col>
              </div>
            </b-form>
            <div class="row justify-content-between">
              <div class="col-4">
                <div class="text-left">
                  <b-button @click="previousDokumen()" variant="primary"><i class="fa fa-caret-left" />
                    Sebelumnya</b-button>
                </div>
              </div>
              <div class="col-4">
                <div class="text-right">
                  <b-button @click="nextDokumen()" style="float: right" variant="primary">Selanjutnya <i
                      class="fa fa-caret-right" /></b-button>
                </div>
              </div>
            </div>
          </tab-content>
          <tab-content title="3. Hasil">
            <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
              <legend><strong>Hasil Penilaian Teknis</strong></legend>
              <legend>Surat Permohonan</legend>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Pejabat Penandatangan Surat *" label-for="form">
                    <b-form-input v-validate="'required'" name="Pejabat Penandatangan Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Pejabat Penandatangan Surat'),
                    }" v-model="dataPermohonan.jenis_surat_penerbitan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Pejabat Penandatangan Surat')">
                      {{ errors.first("form-1.Pejabat Penandatangan Surat") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Nomor Surat *" label-for="form">
                    <b-form-input v-validate="'required'" name="Nomor Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nomor Surat'),
                    }" v-model="dataPermohonan.nomor_surat_penerbitan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Nomor Surat')">
                      {{ errors.first("form-1.Nomor Surat") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Tanggal Surat *" label-for="form">
                    <input type="date" v-validate="'required'" name="Tanggal Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Tanggal Surat'),
                    }" v-model="dataPermohonan.tanggal_surat_penerbitan" />
                    <span class="text-danger" v-if="errors.has('form-1.Tanggal Surat')">
                      {{ errors.first("form-1.Tanggal Surat") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Perihal Surat *" label-for="form">
                    <b-form-input v-validate="'required'" name="Perihal Surat" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Perihal Surat'),
                    }" v-model="dataPermohonan.perihal_surat_penerbitan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Perihal Surat')">
                      {{ errors.first("form-1.Perihal Surat") }}
                    </span>
                  </b-form-group>
                </b-col>


              </b-row>
              
              <legend>Detail Permohonan</legend>
              <b-row>
                <div class="col-md-6">
                  <b-form-group label="Provinsi *" label-for="form">
                    <v-select id="default-select" v-model="dataPermohonan.provinsi"
                      :reduce="(provinsi) => provinsi.nama_provinsi" label="nama_provinsi" :options="dataProvinsi"
                      v-validate="'required'" name="Provinsi" :class="{ 'is-invalid': errors.has('form-1.Provinsi') }"
                      @input="getKabupaten(dataPermohonan.provinsi)" />
                    <span class="text-danger" v-if="errors.has('form-1.Provinsi')">
                      {{ errors.first("form-1.Provinsi") }}
                    </span>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Kabupaten" label-for="form">
                    <v-select id="default-select" v-model="dataPermohonan.kabupaten"
                      :reduce="(kabupaten) => kabupaten.nama_kabupaten" label="nama_kabupaten" :options="dataKabupaten"
                      name="Kabupaten" @input="getKecamatan(dataPermohonan.kabupaten)" />
                    <!-- <span class="text-danger" v-if="errors.has('form-1.Kabupaten')">
                                    {{ errors.first('form-1.Kabupaten') }}
                                </span> -->
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Kecamatan" label-for="form">
                    <v-select id="default-select" v-model="dataPermohonan.kecamatan"
                      :reduce="(kecamatan) => kecamatan.nama_kecamatan" label="nama_kecamatan"
                      :options="dataKecamatan" />
                    <!-- <span class="text-danger" v-if="errors.has('form-1.Kecamatan')">
                                    {{ errors.first('form-1.Kecamatan') }}
                                </span> -->
                  </b-form-group>
                </div>
                <b-col md="6">
                  <b-form-group label="Jenis Dokumen Permohonan: *" label-for="form">
                    <v-select id="default-select" v-model="dataPermohonan.jenis_permohonan"
                      :reduce="(jenis) => jenis.nama" label="nama" :options="dataJenisPermohonan"
                      v-validate="'required'" name="Jenis Dokumen Permohonan" :class="{
                        'is-invalid': errors.has('form-1.Jenis Dokumen Permohonan'),
                      }" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Dokumen Permohonan')">
                      {{ errors.first("form-1.Jenis Dokumen Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <!-- <b-col md="6">
                  <b-form-group label="Klasifikasi Pemohon: *">
                    <v-select
                      id="default-select"
                      v-model="dataPermohonan.klasifikasi_pemohon"
                      :reduce="(klasifikasi) => klasifikasi.nama"
                      label="nama"
                      :options="dataKlasifikasi"
                      v-validate="'required'"
                      name="Klasifikasi Pemohon"
                      :class="{
                        'is-invalid': errors.has('form-3.Klasifikasi Pemohon'),
                      }"
                    />
                    <span
                      class="text-danger"
                      v-if="errors.has('form-3.Klasifikasi Pemohon')"
                    >
                      {{ errors.first("form-3.Klasifikasi Pemohon") }}
                    </span>
                  </b-form-group>
                </b-col> -->
                <b-col md="6">
                  <b-form-group label="Nama Perairan *" label-for="form">
                    <b-form-input v-validate="'required'" name="Nama Perairan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Nama Perairan'),
                    }" v-model="dataPermohonan.nama_perairan" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Nama Perairan')">
                      {{ errors.first("form-1.Nama Perairan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Garis Pantai *" label-for="form">
                    <b-form-input v-validate="'required'" name="Garis Pantai" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Garis Pantai'),
                    }" v-model="dataPermohonan.garis_pantai" type="text" />
                    <span class="text-danger" v-if="errors.has('form-1.Garis Pantai')">
                      {{ errors.first("form-1.Garis Pantai") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Jenis Permohonan: *" label-for="form">
                    <v-select id="default-select" v-model="dataPermohonan.jenis_pnbp" :options="[
                      'Area',
                      'Kabel Bawah Laut',
                      'Pipa Air Bersih / Air Baku',
                      'Pipa Selain Air Bersih / Air Baku',
                    ]" v-validate="'required'" name="Jenis Permohonan"
                      :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }" @input="handleJenisPNBPChange"
                      :multiple="true" :close-on-select="false" />
                    <span class="text-danger" v-if="errors.has('form-1.Jenis Permohonan')">
                      {{ errors.first("form-1.Jenis Permohonan") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="dataPermohonan.jenis_pnbp.includes('Area')">
                  <b-form-group label="Luas (ha) *" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Luas" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Luas'),
                    }" v-model="dataPermohonan.luas" />
                    <span class="text-danger" v-if="errors.has('form-1.Luas')">
                      {{ errors.first("form-1.Luas") }}
                    </span>
                  </b-form-group>
                </b-col>

                <!-- <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut') ||
                  dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') ||
                  dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
                ">
                  <b-form-group label="Panjang (di dalam Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang (di dalam Kws. Konservasi)(km)" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'form-1.Panjang (di dalam Kws. Konservasi)(km)'
                      ),
                    }" v-model="dataPermohonan.panjang_konservasi" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang (di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang (di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut') ||
                  dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') ||
                  dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
                ">
                  <b-form-group label="Panjang (di luar Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang (di luar Kws. Konservasi)(km)" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPermohonan.panjang_nonkonservasi" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang (di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang (di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col> -->

                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
                ">
                  <b-form-group label="Panjang Kabel(di dalam Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang Kabel(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)'
                      ),
                    }" v-model="dataPermohonan.panjang_konservasi_kabel" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
                ">
                  <b-form-group label="Panjang Kabel(di luar Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang Kabel(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPermohonan.panjang_nonkonservasi_kabel" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Kabel(di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') 
                ">
                  <b-form-group label="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)'
                      ),
                    }" v-model="dataPermohonan.panjang_konservasi_pipa_air" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku') 
                ">
                  <b-form-group label="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_air" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
                ">
                  <b-form-group label="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has(
                        'form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)'
                      ),
                    }" v-model="dataPermohonan.panjang_konservasi_pipa_lain" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="
                  dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
                ">
                  <b-form-group label="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
                    <b-form-input min="0" step=".01" type="number" name="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)'),
                    }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_lain" />
                    <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)')">
                      {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)") }}
                    </span>
                  </b-form-group>
                </b-col>


                <b-col md="6">
                  <b-form-group label="Kedalaman (m) *" label-for="form">
                    <b-form-input v-validate="'required'" name="Kedalaman" min="0" step=".01" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Kedalaman'),
                    }" v-model="dataPermohonan.kedalaman" type="number" />
                    <span class="text-danger" v-if="errors.has('form-1.Kedalaman')">
                      {{ errors.first("form-1.Kedalaman") }}
                    </span>
                  </b-form-group>
                </b-col>

                <b-col md="6" v-if="dataPermohonan.tipe_permohonan == 'Multi KBLI'">
                <b-form-group label="Permohonan Proses: *" label-for="form">
                  <v-select id="default-select" v-model="dataPermohonan.nomor_permohonan_proses" :reduce="(data) => data.nomor_permohonan"
                    style="background-color: white !important;" label="nomor_permohonan" :options="dataPermohonanMultiKBLI" placeholder="Pilih permohonan yang akan diproses"
                     v-validate="'required'" name="Permohonan Proses" :class="{ 'is-invalid': errors.has('form-1.Permohonan Proses') }" />
                  
                    <span class="text-danger" v-if="errors.has('form-1.Permohonan Proses')">
                    {{ errors.first("form-1.Permohonan Proses") }}
                  </span>
                </b-form-group>
              </b-col>

                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label="Rencana Detail Kegiatan: *" label-for="form">
                      <b-form-textarea v-validate="'required'" name="Rencana Detail Kegiatan" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Rencana Detail Kegiatan'),
                    }" v-model="dataPermohonan.rencana_detail_kegiatan"
                        placeholder="Masukkan Rencana Detail Kegiatan">

                      </b-form-textarea>

                      <span class="text-danger" v-if="errors.has('form-1.Rencana Detail Kegiatan')">
                      {{ errors.first("form-1.Rencana Detail Kegiatan") }}
                    </span>
                      <!-- <ckeditor
                        :editor="wygEditor"
                        v-model="dataPermohonan.rencana_detail_kegiatan"
                      ></ckeditor> -->
                    </b-form-group>
                  </div>
                </b-col>

                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label="Hasil Penilaian Teknis: *" label-for="form">
                      <ckeditor v-validate="'required'" name="Hasil Penilaian Teknis" :class="{
                      'form-control': true,
                      'is-invalid': errors.has('form-1.Hasil Penilaian Teknis'),
                    }" :editor="wygEditor" v-model="dataPermohonan.hasil_verifikasi_teknis"></ckeditor>
                     <span class="text-danger" v-if="errors.has('form-1.Hasil Penilaian Teknis')">
                      {{ errors.first("form-1.Hasil Penilaian Teknis") }}
                    </span>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col md="12">
                  <div class="form-group mt-2">
                    <b-form-group label="Catatan:" label-for="form">
                      <ckeditor :editor="wygEditor" v-model="dataPermohonan.catatan_vertek"></ckeditor>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <!-- <b-form-group label="Hasil Lain:"></b-form-group>
                        <b-row>
                                <b-col md="6" v-for="(row, index) in dataPermohonan.hasil_tambahan"
                                :key="row.index">
                                <b-input-group class="mb-3">
                                <b-form-textarea
                                    id="textarea-default"
                                    placeholder="Hasil Lain"
                                    v-model="row.data"
                                ></b-form-textarea>
                                <b-input-group-append>
                                    <b-button
                                        variant="danger" style="height:40px; margin-left:5px; border-top-left-radius: 6px; border-bottom-left-radius: 6px;" @click="deleteHasil(index)"
                                    >
                                        <i class="fa fa-trash" />
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        </b-row>
                        <b-button @click="addHasil()" variant="success">
                            <i class="fa fa-plus" />
                        </b-button>
                        <br><br> -->
            </form>
            <div class="row justify-content-between">
              <div class="col-4">
                <div class="text-left">
                  <b-button @click="previousDokumen()" variant="primary"><i class="fa fa-caret-left" />
                    Sebelumnya</b-button>
                </div>
              </div>
              <div class="col-4">
                <div class="text-right">
                  <b-button @click="simpanHasil()" style="float: right" variant="success">Selesai <i
                      class="fa fa-check" /></b-button>
                </div>
              </div>
            </div>
          </tab-content>
        </form-wizard>
      </Widget>
    </b-col>
    <b-modal id="modal-catatan" size="lg" body-class="bg-white" title="Catatan Direktur" ok-only
      cancel-variant="default">
      <div v-html="dataPermohonan.catatan_ba_direktur"></div>
    </b-modal>
  </b-row>
</template>

<script>
import Vue from "vue";
import vSelect from "vue-select";
import Widget from "@/components/Widget/Widget";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import VueLoading from "vuejs-loading-plugin";
import Profil from "../Detail/Profil/Profil.vue";

// using default options
Vue.use(VueLoading);

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: "Loading", // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: "rgb(255,255,255)", // set custom background
  classes: ["myclass"], // array, object or string
});

//   import { select2CountriesData, select2ShipmentData, cardTypesData } from './data';

export default {
  name: "FormWizardPage",
  components: { Widget, vSelect, ClassicEditor, DatePicker, Profil },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      progress: 1,
      dataJenisProyek: [],
      dataRisiko: [],
      dataSkalaUsaha: [],
      dataStatusVerdok: [],
      dataPermohonan: [],
      dataPermohonan: [],
      radioOne: 0,
      wygEditor: ClassicEditor,
      dataJenisPermohonan: [],
      dataKlasifikasi: [],
      dataStatusPentek: [],
      dataHasilPentek: [],
      dataProvinsi: [],
      dataKabupaten: [],
      dataKecamatan: [],
      optionsPrioritas: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      optionsKategori: [
        { value: 'Permohonan Baru', text: "Permohonan Baru" },
        { value: 'Penambahan KBLI', text: "Penambahan KBLI" },
        { value: 'Notifikasi Izin Lokasi', text: "Notifikasi Izin Lokasi" },
      ],
      optionsTipe: [
        { value: 'Single KBLI', text: "Single KBLI" },
        { value: 'Multi KBLI', text: "Multi KBLI" },
      ],

      optionsMultiKBLI: [
        { value: 'Proses', text: "Proses" },
        { value: 'Mengikuti', text: "Mengikuti" },
      ],
      dataUser: [],
      dataKlasifikasi: [],
      dataPermohonanMultiKBLI:[]
    };
  },
  mounted() {
    // this.getRisiko();
    // this.getJenisProyek();
    this.getJenisPermohonan();
    this.getSkalaUsaha();
    this.getStatusVerdok();
    this.getKlasifikasi();
    this.getHasilPentek();
    this.getStatusPentek();
    this.getProvinsi();
    this.getUser();
    this.getKBLI();
    this.loaddata();
    
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        Vue.set(this, "progress", nextIndex + 1);
      }
    },

    changeRadio(field, index) {
      Vue.set(this, field, index);
    },

    //   get jenis proyek
    getJenisProyek() {
      axios
        .get(this.baseapi + "api/jenis_proyek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataJenisProyek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getKBLI() {
      axios
        .get(this.baseapi + "api/kbli", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKBLI = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get status verdok
    getStatusPentek() {
      axios
        .get(this.baseapi + "api/status_vertek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataStatusPentek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    //get Klasifikasi

    getKlasifikasi() {
      axios
        .get(this.baseapi + "api/klasifikasi_pemohon", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKlasifikasi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get hasil vertek
    getHasilPentek() {
      axios
        .get(this.baseapi + "api/hasil_vertek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataHasilPentek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    getUser() {
      axios
        .get(this.baseapi + "api/user", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataUser = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get provinsi
    getProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get kabupaten
    getKabupaten(nama) {
      axios
        .get(this.baseapi + "api/kabupaten?filter=nama_provinsi,=," + nama, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKabupaten = response.data.data;
        })
        .catch((error) => {
          return error;
        });
    },

    getKecamatan(nama) {
      axios
        .get(this.baseapi + "api/kecamatan?filter=nama_kabupaten,=," + nama, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataKecamatan = response.data.data;
        })
        .catch((error) => {
          return error;
        });
    },

    // get jenis Permohonan
    getJenisPermohonan() {
      axios
        .get(this.baseapi + "api/jenis_permohonan", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataJenisPermohonan = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get Permohonan MUlti KBLI
    getPermohonanMulti() {
      axios
        .get(this.baseapi + "api/notifikasi_izin_lokasi?filter=nomor_permohonan_utama,=,"+this.dataPermohonan.nomor_permohonan, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPermohonanMultiKBLI = response.data.data;
          this.dataPermohonanMultiKBLI.unshift(
            this.dataPermohonan
          )
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // get klasifikasi
    // getKlasifikasi() {
    //   axios
    //     .get(this.baseapi + "api/klasifikasi_pemohon", {
    //       headers: {
    //         Authorization: `Bearer ` + this.user.accessToken,
    //       },
    //     })
    //     .then((response) => {
    //       this.dataKlasifikasi = response.data.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       return error;
    //     });
    // },

    simpanProfil() {
      document.getElementById("next").click();
    },

    nextDokumen() {
      document.getElementById("next").click();
    },

    previousDokumen() {
      document.getElementById("back").click();
    },

    // simpan hasil
    simpanHasil() {
      // let array = []
      // for (let index = 0; index < this.dataPermohonan.hasil_tambahan.length; index++) {
      //     array.push(this.dataPermohonan.hasil_tambahan[index].data)
      // }
      this.$validator.validateAll("form-1").then((result) => {
        if (result) {
          this.$loading(true);
          axios
            .put(
              this.baseapi + "api/notifikasi_izin_lokasi/submitPentek",
              {
                id_permohonan: this.$route.params.id,
                jenis_permohonan: this.dataPermohonan.jenis_permohonan,
                jenis_surat_penerbitan: this.dataPermohonan.jenis_surat_penerbitan,
                nomor_surat_penerbitan: this.dataPermohonan.nomor_surat_penerbitan,
                tanggal_surat_penerbitan: this.dataPermohonan.tanggal_surat_penerbitan,
                perihal_surat_penerbitan: this.dataPermohonan.perihal_surat_penerbitan,
                klasifikasi_pemohon: this.dataPermohonan.klasifikasi_pemohon,
                catatan_vertek: this.dataPermohonan.catatan_vertek,
                nama_perairan: this.dataPermohonan.nama_perairan,
                hasil_verifikasi_teknis:
                  this.dataPermohonan.hasil_verifikasi_teknis,
                jenis_pnbp: this.dataPermohonan.jenis_pnbp,
                luas: this.dataPermohonan.luas,
                panjang_konservasi_kabel: this.dataPermohonan.panjang_konservasi_kabel,
                panjang_nonkonservasi_kabel: this.dataPermohonan.panjang_nonkonservasi_kabel,
                panjang_konservasi_pipa_air: this.dataPermohonan.panjang_konservasi_pipa_air,
                panjang_nonkonservasi_pipa_air: this.dataPermohonan.panjang_nonkonservasi_pipa_air,
                panjang_konservasi_pipa_lain: this.dataPermohonan.panjang_konservasi_pipa_lain,
                panjang_nonkonservasi_pipa_lain: this.dataPermohonan.panjang_nonkonservasi_pipa_lain,
                kedalaman: this.dataPermohonan.kedalaman,
                rencana_detail_kegiatan:
                  this.dataPermohonan.rencana_detail_kegiatan,
                provinsi: this.dataPermohonan.provinsi,
                kabupaten: this.dataPermohonan.kabupaten,
                kecamatan: this.dataPermohonan.kecamatan,
                garis_pantai: this.dataPermohonan.garis_pantai,
                list_kbli: this.dataPermohonan.kbli,
                nomor_permohonan_proses: this.dataPermohonan.nomor_permohonan_proses
              },
              {
                headers: {
                  Authorization: `Bearer ` + this.user.accessToken,
                },
              }
            )
            .then((res) => {
              this.$toasted.success("Berhasil Disimpan");
              this.$loading(false);
              document.getElementById("finish").click();

              return res;
            })
            .catch((err) => {
              this.$loading(false);
              console.log(err);
              this.$toasted.error(err.response.data.message);
              // document.getElementById("finish").click();
              return err;
            });
        }
      });
    },



    // get prvonsin
    getProvinsi() {
      axios
        .get(this.baseapi + "api/provinsi", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataProvinsi = response.data.data;
        })
        .catch((error) => {
          return error;
        });
    },

    // get skala usaha
    getSkalaUsaha() {
      axios
        .get(this.baseapi + "api/skala_usaha", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataSkalaUsaha = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },

    // load data
    loaddata() {
      axios
        .get(this.baseapi + "api/notifikasi_izin_lokasi/" + this.$route.params.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataPermohonan = response.data.data;
          this.dataPermohonan["file_1"] = null;
          this.dataPermohonan["file_2"] = null;
          this.dataPermohonan["file_3"] = null;
          this.dataPermohonan["file_4"] = null;
          this.dataPermohonan["file_5"] = null;
          this.dataPermohonan["file_6"] = null;

          //kosongk kan field hasil

          // if(this.dataPermohonan.jenis_permohonan == null){
          //   this.dataPermohonan.jenis_pnbp = null
          //   this.dataPermohonan.nama_perairan = null
          //   this.dataPermohonan.luas = null
          //   this.dataPermohonan.panjang_konservasi = null
          //   this.dataPermohonan.panjang_nonkonservasi = null
          // }

          if (this.dataPermohonan.hasil_tambahan === null) {
            this.dataPermohonan.hasil_tambahan = [];
          } else {
            let array = [];
            array = this.dataPermohonan.hasil_tambahan.split("||");
            console.log(array);

            let array2 = [];

            for (let index = 0; index < array.length; index++) {
              array2.push({ data: array[index] });
            }
            array = this.dataPermohonan.hasil_tambahan = array2;
          }
          console.log(this.dataPermohonan);
        })
        .catch((error) => {
          console.log(error);
          return error;
        }).finally(() => {
          if(this.dataPermohonan.provinsi){
            this.getKabupaten(this.dataPermohonan.provinsi)
          }

          this.getPermohonanMulti()
        });
    },

    // tambah hasil lain
    addHasil() {
      this.dataPermohonan.hasil_tambahan.push({ data: null });
    },

    // delete hasil lain
    deleteHasil(index) {
      this.dataPermohonan.hasil_tambahan.splice(index, 1);
    },

    // get status verdok
    getStatusVerdok() {
      axios
        .get(this.baseapi + "api/status_verdok", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataStatusVerdok = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    
    handleJenisPNBPChange(selected) {
      console.log(selected)
      
      if(!selected.includes("Area")){
        this.dataPermohonan.luas = null;
      }

      if(!selected.includes('Kabel Bawah Laut')){
        this.dataPermohonan.panjang_konservasi_kabel = null;
        this.dataPermohonan.panjang_nonkonservasi_kabel = null;
      }

      if(!selected.includes('Pipa Air Bersih / Air Baku')){
        this.dataPermohonan.panjang_konservasi_pipa_air = null;
        this.dataPermohonan.panjang_nonkonservasi_pipa_air = null;
      }

      if(!selected.includes('Pipa Selain Air Bersih / Air Baku')){
        this.dataPermohonan.panjang_konservasi_pipa_lain = null;
        this.dataPermohonan.panjang_nonkonservasi_pipa_lain = null;
      }
      
      

      // console.log(selected.length)
      // if (selected.length > 2) {
      //   selected.pop(); // buang pilihan terakhir
      //   this.$toasted.error("Maksimal 2 Jenis Permohonan")
      // }
      // if ((selected.length === 2 && selected.includes('Area') == false)) {
      //   this.$toasted.error("Salah Satu Jenis Permohonan Wajib Pilih Area")
      //   return selected.pop();
      // }
      // this.dataPermohonan.jenis_pnbp = selected;
    },
  },
};
</script>

<style src="../Wizard.scss" lang="scss" />